import styled, { css } from 'styled-components';
import { TextareaAppearance } from './Textarea.types';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { removeScrollbar } from '@/styles/helpers';

export const TextareaHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const TextareaFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
`;

export const TextareaLabel = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const TextareaSymbolsCount = styled(Typography.Caption)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const TextareaField = styled.textarea<{
  $height?: number;
  $maxHeight?: number;
  $minHeight?: number;
  $hasScrollbar?: boolean;
  $appearance?: TextareaAppearance;
  $hasError?: boolean;
}>`
  ${({ $hasScrollbar }) => ($hasScrollbar ? '' : removeScrollbar())}

  background-color: ${({ theme }) => theme.palette.secondary.background};
  border: 0;
  outline: 0;
  font-size: 15px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.palette.primary.labels};
  width: 100%;
  resize: none;
  border-radius: 7px;
  padding: 15px;
  height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};
  vertical-align: top;
  box-sizing: border-box;
  overflow-y: auto;

  &::-webkit-scrollbar-thumb {
    border-radius: 14px;
    background-clip: padding-box;
    border: 4px solid transparent;
    background-color: ${({ theme }) => theme.palette.system.scrollbar};
    cursor: default;
    min-height: 25px;
  }

  &::-webkit-scrollbar {
    width: 16px;
  }

  &::-webkit-scrollbar-track {
    margin: 5px 0;
    background: transparent;
  }

  ${({ $minHeight }) =>
    $minHeight &&
    css`
      min-height: ${$minHeight}px;
    `}

  ${({ $maxHeight }) =>
    $maxHeight &&
    css`
      max-height: ${$maxHeight}px;
    `}

  &::placeholder {
    color: ${({ theme }) => theme.palette.secondary.labels};
  }

  ${({ $appearance, $hasError }) =>
    $appearance === 'quartenary' &&
    css`
      background-color: ${({ theme }) => theme.palette.quartenary.background};
      border: 1px solid ${({ theme }) => theme.palette.primary.border};
      border-radius: 14px;

      &:focus {
        border: 1px solid ${({ theme }) => theme.palette.brand.main};
      }

      ${$hasError &&
      css`
        background-color: ${({ theme }) => theme.palette.system.redToWhite};
        border: 1px solid ${({ theme }) => theme.palette.system.red};
      `}
    `}
`;
